/**
 * CalendarView Component
 * Main container that renders the active calendar view (Day, Week, or Month).
 * Includes the CalendarHeader and conditionally renders the appropriate view.
 */

import { useCalendarStore, CalendarView as ViewType } from '@/stores/calendarStore';
import { CalendarHeader } from './CalendarHeader';
import { CalendarFilterBar } from './CalendarFilterBar';
import { WeekView } from './views/WeekView';
import { MonthView } from './views/MonthView';

/**
 * Renders the appropriate view component based on currentView state.
 */
function ViewRenderer({ view }: { view: ViewType }) {
  switch (view) {
    case 'week':
      return <WeekView />;
    case 'month':
      return <MonthView />;
    default:
      return <WeekView />;
  }
}

/**
 * Main CalendarView container.
 * Renders the header and the active view in a flex column layout.
 */
export function CalendarView() {
  const currentView = useCalendarStore((state) => state.currentView);

  return (
    <div className="flex flex-col h-full w-full bg-white">
      <CalendarHeader />
      <CalendarFilterBar />
      <ViewRenderer view={currentView} />
    </div>
  );
}

export default CalendarView;
